import { CustomTable } from "@/components/Tables/CustomTable"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddCashDenominationModal from "@/pages/cash-denominations/AddCashDenominationModal"
import { columns } from "@/pages/cash-denominations/Columns"
import { useMemo, useState } from "react"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs"
import { useAppSelector } from "@/lib/hooks"
import { isAdminPortal } from "@/utilities/domain"
import {
  ReportBranchFilter,
  ReportBranchProvider,
  useReportBranch,
  withBranchColumn,
} from "@/components/Reports/ReportBranchFilter"

const adminColumns = withBranchColumn(columns)

export default function CashDenominationList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/pos/dashboard" },
    { label: "Cash Denomination" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Cash Denomination</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      {isAdminPortal() ? (
        <ReportBranchProvider>
          <AdminCashDenominationTable />
        </ReportBranchProvider>
      ) : (
        <CrudProvider>
          <CashDenominationTable />
        </CrudProvider>
      )}
    </>
  )
}

function CashDenominationTable() {
  const [editData, setEditData] = useState(null)
  const permissions = new Set(
    useAppSelector((state) => state.auth.user?.permissions ?? [])
  )
  const {
    setOpenDialog,
    openDialog,
    setSelectedRow: setModelSelectedRow,
  } = useCrudContext()
  const onEdit = (data) => {
    setEditData(data)
    console.log("editdata", editData)
    setOpenDialog(true)
  }
  return (
    <>
      <CustomTable
        label="Cash Sessions"
        columns={columns}
        addBtn={true}
        apiPath="cash"
        showDelete={false}
        onEdit={onEdit}
        onExport={permissions.has("operations-exports-create")}
      />

      {(openDialog || editData) && (
        <AddCashDenominationModal
          editData={editData}
          onClose={() => setEditData(null)}
        />
      )}
    </>
  )
}

// Company administrators review every branch's cash sessions, or a selected
// one; sessions are opened and closed on the branch portals.
function AdminCashDenominationTable() {
  const { branchId } = useReportBranch()
  const branchFilter = useMemo(() => ({ branch_id: branchId }), [branchId])

  return (
    <CustomTable
      label="Cash Sessions"
      columns={adminColumns}
      apiPath="cash"
      addBtn={false}
      showEdit={false}
      showDelete={false}
      onExport
      hardcodedFilters={branchFilter}
      exportParams={branchFilter}
      renderFilters={() => <ReportBranchFilter sx={{ mb: 0 }} />}
    />
  )
}
